// extracted by mini-css-extract-plugin
export default {"home":"Home_home__m+Y9x","gradient":"Home_gradient__rcOmA","content":"Home_content__GWLDp"};